// Shared EmptyState — centred icon, heading, one line of help and an
// optional action, for empty and not-found screens (DEV-51010).
import clsx from 'clsx'

export interface EmptyStateProps {
  /** Icon element, sized ~40px; shown in a grey circle. */
  icon: React.ReactNode
  title: string
  description: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={clsx('flex flex-col items-center py-14 text-center', className)}>
      <div className="mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-gray-100">
        {icon}
      </div>
      <h2 className="mb-2 max-w-full break-words text-xl font-bold text-gray-900">{title}</h2>
      <p className="mb-6 max-w-[20rem] text-base text-gray-500">{description}</p>
      {action}
    </div>
  )
}
